



































import { Vue, Component, Watch } from 'vue-property-decorator';
import ReportPage from '../../components/report/ReportPage.vue';
import { dayjs, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import { Session } from '../../utils/Session';
import { URIs } from '../../../src_server/common/URIs';
import { ResultReportDTO } from '../../../src_server/entity/dto/ResultReportDTO';
import { AdminService } from '../../biz/remote/AdminService';

@Component({ components: { ReportPage } })
export default class AdminDailyReportDocPage extends Vue {
  private termOfDate = dayjs().add(1, 'month').date(25).format('YYYY-MM-DD');

  private rows: ResultReportDTO[] = [];
  private target_month: string = dayjs().format(MONTH_FORMAT);
  private cols: TableColumn[] = [
    {
      label: 'No',
      name: 'no',
      type: 'seq',
      width: '10px',
    },

    {
      label: '生徒名',
      name: 'student_name',
      width: '100px',
    },
    {
      label: '先生名',
      name: 'teacher_name',
      width: '100px',
    },
    {
      label: '日時',
      name: 'lesson_dt',
      type: 'datetime',
      width: '130px',
    },
    {
      label: '予ステ',
      name: 'reservation_state',
      width: '80px',
    },

    {
      label: '本日の狙い',
      name: 'lesson_goal',
      width: '180px',
    },

    {
      label: '達成率',
      name: 'goal_rate',
      width: '100px',
    },

    {
      label: '流れ',
      name: 'lesson_point',
      width: '',
    },

    {
      label: '振り返り',
      name: 'student_state',
      width: '',
    },

    {
      label: '先生コメント',
      name: 'to_parent',
      width: '',
    },

    {
      label: '評価',
      name: 'evaluation',
      width: '10px',
    },

    {
      label: '保護者コメント',
      name: 'comment',
      width: '',
    },
  ];

  @Watch('target_month')
  async load() {
    const target = this.target_month;

    console.log('Session.getSessionBuildingId()', Session.getSessionBuildingId());
    const biz = new AdminService();
    const response = await biz.getResultReportList(target, Session.getSessionBuildingId());
    this.rows = response.data;
    // this.rows = [new ResultReportDTO()];
  }

  async exportCSV() {
    const url = `${URIs.RESULT_REPORT_LIST_CSV_DOWNLOAD.path}?month=${this.target_month}&building_id=${Session.getSessionBuildingId()}&token=${Session.getJwtToken()}`;
    location.href = url;
  }

  prevMonth() {
    this.target_month = dayjs(this.target_month).add(-1, 'month').format(MONTH_FORMAT);
  }
  currentMonth() {
    this.target_month = dayjs().format(MONTH_FORMAT);
  }
  nextMonth() {
    this.target_month = dayjs(this.target_month).add(1, 'month').format(MONTH_FORMAT);
  }

  async created() {
    this.load();
  }
}
